// Port de app/(tabs)/ronda.tsx.
import { Carregando } from "@/app/Carregando";
import { useIsFocused } from "@/navigation";
import { lazy } from "react";

const RondaScreen = lazy(() => import("@/screens/Ronda"));

export default function RondaRoute() {
  const focused = useIsFocused();
  return focused ? (
    <Carregando>
      <RondaScreen />
    </Carregando>
  ) : null;
}
